import { connect } from 'react-redux';
import { ICustomPropertyHOCProps } from './types';
import { CustomProperty } from '../../components/CustomProperty/CustomProperty';
import { ICustomPropertyEvents, ICustomPropertyFields } from '../../components/CustomProperty/types';
import { onUpdateValue } from './events/onUpdateValue';
import { IApplicationState } from '../../../../../../../types/types';
import { getCardCalendarCustomEvents } from '../../../../../../../store/model/selectors/getCardCalendarCustomEvents';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../aside_panel/effects/showBoardLimitSnackbarIfNeeded';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, customProperty, isPopup, isReadonly, isHideCloseButton }: ICustomPropertyHOCProps
): ICustomPropertyFields => {
    const calendarEvents = getCardCalendarCustomEvents(state, cardId);
    return {
        cardId,
        customProperty,
        isHideCloseButton,
        isDatePushed: !!calendarEvents.find(item => item.type === customProperty.id),
        isPopup,
        isReadonly,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, onCancel, onChange, onEdit, setCardHeight, onHeightChange, onToggleLoadingImg, onFocus, onBlur }: ICustomPropertyHOCProps
): ICustomPropertyEvents => {
    return {
        onBlur,
        onCancel,
        onChange,
        onEdit,
        onFocus,
        onHeightChange,
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
        onToggleLoadingImg,
        onUpdateValue: (customPropertyId, value) => dispatch(onUpdateValue(cardId, customPropertyId, value)),
        setCardHeight,
    };
};

export const CustomPropertyHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomProperty);

CustomPropertyHOC.displayName = 'CustomPropertyHOC';
